import { useEffect } from 'react';

import { loginTx } from '../i18n/loginTx';
import { getTransifexLocale, useSystemLocale } from '../utils/getSystemLocale';

export const useLanguageSetting = () => {
  const locale = useSystemLocale();

  useEffect(() => {
    const current = loginTx.getCurrentLocale();
    const next = getTransifexLocale(locale);
    if (next !== current) {
      loginTx.setCurrentLocale(next);
    }
  }, [locale]);
};
